import { render, staticRenderFns } from "./EnterpriseUpsellBadge.vue?vue&type=template&id=34b78f66"
import script from "./EnterpriseUpsellBadge.vue?vue&type=script&lang=ts"
export * from "./EnterpriseUpsellBadge.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports